import { useEffect } from 'react';
import { useAppDispatch, useTypedSelector } from 'src/store/index';
import { setPopup } from 'src/store/src/popup';
import { PopupTypesWew } from 'src/store/src/popup/popup/types';

export const useCheckIsPopupToDisplay = () => {
    const dispatch = useAppDispatch();
    const alertsData = useTypedSelector((state) => state.alertsData);
    useEffect(() => {
        if (alertsData.alerts.length) {
            const alert = alertsData.alerts[0];
            dispatch(
                setPopup({
                    type: 'alert',
                    typeWew: alert?.type as PopupTypesWew,
                    isPossibleClose: alert?.type === 'changePassword' ? false : true,
                    message: alert?.type === 'message' ? alert.data.message : undefined
                })
            );
        }
    }, [alertsData, dispatch]);
};
